// extracted by mini-css-extract-plugin
export default {"register":"Register_register__Ri6ng","registerForm":"Register_registerForm__bockB","alreadyAccount":"Register_alreadyAccount__87zv3","googleButton":"Register_googleButton__A5Pli"};